// eslint-disable-next-line import/no-cycle
import {

    // Housekeeping Management
    HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE,
    HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE_SUCCESS,
    HOUSEKEEPING_MANAGEMENT_CREATE_HOUSEKEEPING,
    HOUSEKEEPING_MANAGEMENT_UPDATE_HOUSEKEEPING,
    HOUSEKEEPING_MANAGEMENT_DELETE_HOUSEKEEPING,

    // HOUSEKEEPING_MANAGEMENT_LOAD_POSITION,
    // HOUSEKEEPING_MANAGEMENT_LOAD_POSITION_SUCCESS,
    // HOUSEKEEPING_MANAGEMENT_CREATE_POSITION,
    // HOUSEKEEPING_MANAGEMENT_UPDATE_POSITION,
    // HOUSEKEEPING_MANAGEMENT_DELETE_POSITION,

    // HOUSEKEEPING_MANAGEMENT_LOAD_STAFF,
    // HOUSEKEEPING_MANAGEMENT_LOAD_STAFF_SUCCESS,
    // HOUSEKEEPING_MANAGEMENT_CREATE_STAFF,
    // HOUSEKEEPING_MANAGEMENT_UPDATE_STAFF,
    // HOUSEKEEPING_MANAGEMENT_DELETE_STAFF,
    // END Housekeeping Management

} from '../actions';


// export const settingErrorMessage = (data) => ({
//     type: HOUSEKEEPING_MANAGEMENT_ERROR_MESSAGE,
//     payload: data
// })

// export const closeSettingErrorMessage = () => ({
//     type: CLOSE_HOUSEKEEPING_MANAGEMENT_ERROR_MESSAGE
// });

// // -------------------- Housekeeping Management --------------------- //
export const getHousekeepingByTime = (data, token) => ({
    type: HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE,
    payload: data,
    token
});
export const getHousekeepingByTimeSuccess = (data, list) => ({
    type: HOUSEKEEPING_MANAGEMENT_LOAD_HOUSEKEEPING_BY_DATE_SUCCESS,
    payload: data,
    payloadlist: list
});
export const addHousekeeping = (data, token) => ({
    type: HOUSEKEEPING_MANAGEMENT_CREATE_HOUSEKEEPING,
    payload: data,
    token
});
export const updateHousekeeping = (data, token) => ({
    type: HOUSEKEEPING_MANAGEMENT_UPDATE_HOUSEKEEPING,
    payload: data,
    token
});
export const deleteHousekeeping = (data, token) => ({
    type: HOUSEKEEPING_MANAGEMENT_DELETE_HOUSEKEEPING,
    payload: data,
    token
});
//
// export const getPosition = (data, token) => ({
//     type: HOUSEKEEPING_MANAGEMENT_LOAD_POSITION,
//     payload: data,
//     token
// });
// export const getPositionSuccess = (data, list) => ({
//     type: HOUSEKEEPING_MANAGEMENT_LOAD_POSITION_SUCCESS,
//     payload: data,
//     payloadlist: list
// });
// export const addPosition = (data, token) => ({
//     type: HOUSEKEEPING_MANAGEMENT_CREATE_POSITION,
//     payload: data,
//     token
// });
// export const updatePosition = (data, token) => ({
//     type: HOUSEKEEPING_MANAGEMENT_UPDATE_POSITION,
//     payload: data,
//     token
// });
// export const deletePosition = (data, token) => ({
//     type: HOUSEKEEPING_MANAGEMENT_DELETE_POSITION,
//     payload: data,
//     token
// });
// //
// export const getStaff = (data, token) => ({
//     type: HOUSEKEEPING_MANAGEMENT_LOAD_STAFF,
//     payload: data,
//     token
// });
// export const getStaffSuccess = (data, list) => ({
//     type: HOUSEKEEPING_MANAGEMENT_LOAD_STAFF_SUCCESS,
//     payload: data,
//     payloadlist: list
// });
// export const createStaff = (data, token) => ({
//     type: HOUSEKEEPING_MANAGEMENT_CREATE_STAFF,
//     payload: data,
//     token
// });
// export const updateStaff = (data, token) => ({
//     type: HOUSEKEEPING_MANAGEMENT_UPDATE_STAFF,
//     payload: data,
//     token
// });
// export const deleteStaff = (data, token) => ({
//     type: HOUSEKEEPING_MANAGEMENT_DELETE_STAFF,
//     payload: data,
//     token
// });
// // -------------------- END Housekeeping Management --------------------- //